import I18n from "i18n-js"
import en from "../translations/en.json"

I18n.translations["en"] = en

I18n.fallbacks = true

export default I18n
